import { http } from './http';
import type { UploadResponse } from './types';

export const filesApi = {
  /**
   * Upload a single file via multipart/form-data.
   * Returns the fileAssetId to use when creating photo/audio timeline events.
   *
   * @param file        - File to upload (from input or Capacitor Camera)
   * @param onProgress  - Optional progress callback (0–100)
   */
  upload(file: File, onProgress?: (pct: number) => void): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return http
      .post<UploadResponse>('/files', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: onProgress
          ? (evt) => {
              const pct = evt.total
                ? Math.round((evt.loaded * 100) / evt.total)
                : 0;
              onProgress(pct);
            }
          : undefined,
      })
      .then((r) => r.data);
  },

  /**
   * Download a file asset as a Blob.
   * The Authorization header is automatically added by the http interceptor.
   * Used by AuthImage / AuthAudio to create object URLs without exposing the JWT to src attributes.
   */
  downloadBlob(fileAssetId: string, signal?: AbortSignal): Promise<Blob> {
    return http
      .get<Blob>(`/files/${fileAssetId}/download`, { responseType: 'blob', signal })
      .then((r) => r.data);
  },
};
